import React, { useEffect, useState } from "react";
import { Layout, Modal } from "components";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  DEFAULT_ROUTE,
  APPOINTMENT_BOOKING,
  MAIN,
  APPOINTMENT_EXISTENCE,
  BOOKED,
  NO_APPOINTMENT
} from "constants/route";
import { useSelector, useDispatch, batch } from "react-redux";
import { changeNric } from "redux/appointment";
import {
  existedAppointmentBooking,
  appointmentTakenUp,
  getServiceChannels,
  getCrpsDob
} from "services/api-service";
import { updateAppointmentInfo, changeAge } from "redux/appointment";
import { updateAppointmentBookingInfo } from "redux/appointmentBooking";
import { changeOtpAppointmentExistence, updateServices } from "redux/services";
import axios from "axios";
import { env } from "../env";
import _ from "lodash";

import moment from "moment";
import { YEAR_MONTH_DAY_2, YEAR_MONTH_DAY } from "constants/date";
import { HomeButton } from "components/CommonUI";

const ZERO = 0;

export default function SingPass() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [channels, setChannels] = useState([]);
  const [hasFetched, setHasFetched] = useState(false);

  const { isLogin } = useSelector((state) => state.signPassIdentify);
  const { nric, age } = useSelector((state) => state.appointment);
  const { previousRouteName, selectedApptType } = useSelector(
    (state) => state.appointmentBooking
  );

  const { subServiceId, isCrps } = useSelector((state) => state.services);
  // const { selectedApptType } = useSelector((state) => state.appointmentBooking);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    // const res = await axios.get(
    //   `${env.apiUrl}/api/sp/simulate/accessProtectedResource`,
    //   {
    //     withCredentials: true
    //   }
    // );

    let dob;
    if (!isLogin) return;
    // if (res.data.data) {
    const { data: crpsDob } = await getCrpsDob();

    console.log("crpsDob", crpsDob);

    if (!crpsDob.dateOfBirth || typeof crpsDob.dateOfBirth === "undefined") {
      // alert(crpsDob + "$" + crpsDob.dateOfBirth);
      setHasFetched(true);
      setChannels([]);
      return;
    }
    dob = crpsDob.dateOfBirth;
    batch(() => {
      // dispatch(changeNric(res.data.data));
      dispatch(changeAge(moment(crpsDob.dateOfBirth).format(YEAR_MONTH_DAY)));
    });

    const { data: serviceChannels } = await getServiceChannels(
      "",
      subServiceId,
      false
    );

    // @TODO: filter by specific service channel
    // @TODO: server side check for validity of the service channel
    // if(serviceChannels.data) {
    //   const foundServiceChannel = serviceChannels.data.find(x=>x.id === selectedApptType.value)
    //   if(foundServiceChannel) {
    //     setChannels(serviceChannels.data);
    //     return;
    //   }
    // }
    // setChannels([]);

    if (serviceChannels.data) {
      setChannels(serviceChannels.data);
      setHasFetched(true);
    }
    // }
  }, [isLogin]);

  const goHome = () => navigate(DEFAULT_ROUTE);

  const handleNext = async () => {
    const res = await existedAppointmentBooking(nric);
    if (_.isEmpty(res.data) && previousRouteName === MAIN) {
      // setErrorMessage(res.data);
      // setIsOpenModal(true);
      navigate(NO_APPOINTMENT, {
        replace: true
      });
      return;
    }

    if (selectedApptType.value) {
      const { data: response } = await appointmentTakenUp(
        selectedApptType.value,
        moment().format(YEAR_MONTH_DAY_2)
      );

      if (response.data.length === ZERO) {
        navigate(BOOKED);
        return;
      }
    }

    if (previousRouteName !== MAIN && _.isEmpty(res.data)) {
      navigate(APPOINTMENT_BOOKING, {
        replace: true
      });
      return;
    }

    const data = res.data;
    batch(() => {
      dispatch(updateAppointmentInfo(data));
      dispatch(updateAppointmentBookingInfo(data));
      dispatch(updateServices(data));
    });

    navigate(APPOINTMENT_EXISTENCE, {
      replace: true
    });
    dispatch(
      changeOtpAppointmentExistence({
        mainId: data.service_id,
        subServiceId: data.sub_service_id,
        mainWebDisplayText: data.scheme
      })
    );
  };

  // const goPrevious = () => {
  //   setErrorMessage("");
  //   setIsOpenModal(false);
  //   navigate(-1);
  // };

  // const body = (
  //   <div className="center">
  //     <h3>Contact OTP</h3>
  //     <p>Your filling data will be deleted.</p>
  //   </div>
  // );

  // const footer = (
  //   <div>
  //     <Button
  //       className="btn cmp-button pbs-style--primary rounded-pill me-3"
  //       onClick={goHome}
  //     >
  //       No
  //     </Button>
  //     <Button
  //       className="btn cmp-button pbs-style--primary rounded-pill"
  //       onClick={goPrevious}
  //     >
  //       Yes
  //     </Button>
  //   </div>
  // );

  if (!isLogin && window.appMode !== "DEV") {
    // UAT or PROD
    // alert("no session");
    window.location.href = window.mainLoginUrl;
    return <></>;
  }

  if (nric && isLogin && !isCrps) {
    handleNext();
    return <></>;
  }

  // Crps, age valid, already login
  if (isCrps && channels.length != ZERO && isLogin) {
    handleNext();
    return <></>;
  }

  if (window.appMode != "DEV" && !hasFetched) {
    return <Layout subHeader={"How can we help?"}>&nbsp;</Layout>;
  }

  return (
    <Layout subHeader={"How can we help?"}>
      {hasFetched && isLogin && channels.length === ZERO && isCrps ? (
        <div className="form-box">
          <div className="center my-5">
            <div
              className="my-5 mx-3"
              style={{ paddingLeft: 60, paddingRight: 60 }}
            >
              <h3 style={{ paddingBottom: 20 }}>Oops!</h3>
              <p className="text-justify">
                Seems like you do not meet the age eligibility for CRPS. The
                CRPS is tailored to help members in these groups plan for their
                retirement:
              </p>

              <ol type="i" className="text-justify mt-3">
                <li>Members reaching 55 in 6 months or less, or</li>
                <li>
                  Members reaching Payout Eligibility Age (65 year old) in 3
                  months or less.
                </li>
              </ol>
            </div>
            <div className="form-footer">
              <HomeButton />
            </div>
          </div>
        </div>
      ) : (
        <>
          <div className="d-flex flex-column justify-content-center align-items-center my-3">
            <h2 className="my-3">Sing Pass</h2>
            {!isLogin && window.appMode === "DEV" && (
              <img
                style={{ width: 250, height: 500, display: "block" }}
                alt="singpass icons"
                src="singpass.png"
              />
            )}
          </div>
          <div className="row d-flex justify-content-center my-5">
            <div className="p-0 col-md-8 col-sm-12">
              <Button
                className="btn cmp-button pbs-style--primary rounded-pill me-3"
                onClick={goHome}
                style={{ width: 120 }}
              >
                Home Page
              </Button>
              {nric && isLogin && (
                <Button
                  className="btn cmp-button pbs-style--primary rounded-pill "
                  style={{ width: 120 }}
                  onClick={handleNext}
                >
                  Next
                </Button>
              )}
            </div>
          </div>
        </>
      )}

      {/* <Modal isOpen={true} body={body} footer={footer} closeButton={false} /> */}
    </Layout>
  );
}
